<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3b" id="ch00_fm06"><a id="page_ix"></a>Acknowledgments</h3>
<p class="noindent">Editing a collection of essays sounds much easier than it is. Despite the times I couldn’t stand to look at these pages any longer, I’d still like to thank Larry Eldridge, who originally came up with the topic for this book. I also want to thank Jennifer Hammer, my editor at New York University Press, for seeing me through the editing process. Despina Papazoglou Gimbel, managing editor, and her assistant, Andrew Katz, showed great patience while waiting for my revised manuscript. In addition, I offer grateful thanks to the authors who contributed to this volume. Not only have they written great essays, but they returned revisions on time and without arguments.</p>
<p class="indent">My husband, Doug, read drafts of the manuscripts and helped with computer problems. My daughters, Megan and Sheryl, let me work without too many distractions as my deadline neared, at least most of the time. The love of the three of them keeps me going.</p>
<p class="indent">Deborah Mosley-Duffy provided much-needed encouragement and support when needed.</p>
<p class="indent">Thanks to all of you.<a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06.vue?96cd53f0